const errors = {
  "auth/invalid-email": "E-mail invalide",
  "auth/user-not-found": "Utilisateur non trouvé",
  "auth/user-disabled": "Utilisateur désactivé",
  "auth/wrong-password": "E-mail ou mot de passe invalide",
  "auth/email-already-in-use": "E-mail déjà utilisé",
  "auth/operation-not-allowed": "E-mail ou mot de passe invalide.",
  "auth/weak-password": "Mot de passe trop simple",
  "permission-denied": "Une erreur est survenue, veuillez réessayer plus tard.",
  default: "Une erreur est survenue, veuillez réessayer plus tard."
};

export const errorByCode = code => errors[code] || errors.default;



// WEBPACK FOOTER //
// ./src/services/firebase/errors.js